import { render, staticRenderFns } from "./schoolOptions.vue?vue&type=template&id=5da3dba7&scoped=true&"
import script from "./schoolOptions.vue?vue&type=script&lang=js&"
export * from "./schoolOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da3dba7",
  null
  
)

export default component.exports